/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemPreviewDetailViewModel } from "../types/ExamItemPreviewDetailViewModel.ts";

export const examItemPreviewDetailViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da questão.")),
  active: z.optional(z.boolean().describe("Indica se a questão está ativa.")),
  componentType: z
    .string()
    .describe(
      "Descrição textual do tipo de componente da questão (ex: SingleChoice, MultilineText). Opcional.",
    )
    .nullish(),
  cultureInfo: z
    .string()
    .describe(
      "Código de cultura do idioma da questão (ex: pt-BR, en-US). Opcional.",
    )
    .nullish(),
  decimalPlaces: z
    .number()
    .int()
    .describe("Número de casas decimais para questões numéricas. Opcional.")
    .nullish(),
  filePath: z
    .string()
    .describe("Caminho do arquivo de mídia associado à questão. Opcional.")
    .nullish(),
  fileName: z
    .string()
    .describe("Nome do arquivo de mídia associado à questão. Opcional.")
    .nullish(),
  label: z
    .string()
    .describe("Enunciado da questão (pode conter HTML). Opcional.")
    .nullish(),
  information: z
    .string()
    .describe(
      "Informação complementar exibida ao aluno junto ao enunciado. Opcional.",
    )
    .nullish(),
  pageBreak: z
    .string()
    .describe(
      "Configuração de quebra de página da questão (valor serializado). Opcional.",
    )
    .nullish(),
  showInformation: z
    .string()
    .describe(
      "Configuração de exibição da informação complementar (valor serializado). Opcional.",
    )
    .nullish(),
  showLabel: z
    .string()
    .describe(
      "Configuração de exibição do enunciado (valor serializado). Opcional.",
    )
    .nullish(),
  isFileImage: z.optional(
    z
      .boolean()
      .describe("Indica se o arquivo de mídia associado é uma imagem."),
  ),
}) as unknown as ToZod<ExamItemPreviewDetailViewModel>;
